export default __webpack_public_path__ + "static/media/linkedin.7194c524.svg";